import { render, staticRenderFns } from "./SignUpConfirmation.vue?vue&type=template&id=f0d879a8&scoped=true&"
import script from "./SignUpConfirmation.vue?vue&type=script&lang=js&"
export * from "./SignUpConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d879a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
